import Diagnostics from 'components/view/diagnostics/Index'
import {tabNames, TabType} from 'router/settings'
import {StateDeclaration} from '@uirouter/core'
import {GridStateParamsType} from 'commonTypes'
import defaultDiagnosticsState from '../../redux/diagnostics/state'

const diagnosticsState = {
  name: 'diagnostics',
  url: '/diagnostics',
  component: Diagnostics,
  resolve: [{
    token: 'title',
    resolveFn: () => tabNames[TabType.diagnostics],
  }],
  params: {
    filters: defaultDiagnosticsState.gridSession.filters,
    pagination: defaultDiagnosticsState.gridSession.pagination,
    sorting: defaultDiagnosticsState.gridSession.sorting,
  } as GridStateParamsType,
} as StateDeclaration

export default diagnosticsState
